import React, { useEffect, useState, useContext, useMemo } from "react";
import { AuthContext } from "../../Routes/AuthProvider";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { GetPlan, GetSelectedInsurance } from "../../Services/InsuranceApi";
import Header from "../../Components/Header";
import InsuLeftfilter from "../Insurance/InsuLeftfilter";
import ModifySerchResult from "../Insurance/ModifySerchResult";

const InsuranceAPI_StaticFile_BASE_URL = process.env.REACT_APP_InsuranceAPI_StaticDoc_BASE_URL;

const Insresult = () => {
  const { userName, corporateId } = useContext(AuthContext);

  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const referenceNoFromUrl = searchParams.get("referenceNo") || "";

  const searchData = location.state?.searchData;

  const [insurancePlans, setInsurancePlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [filters, setFilters] = useState({});
  const [key, setKey] = useState(location.state?.insuranceKey || "");
  const [currencyList, setCurrencyList] = useState([
    {
      "id": "104cc3ba-01b4-4ba0-8954-13b12f731e91",
      "currency": "USD",
      "code": "USD",
      "symbol": "$"
    },
    {
      "id": "ce7db96f-0e13-4a42-a847-dd1f10f1fede",
      "currency": "SGD",
      "code": "SGD",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0920eb",
      "currency": "EURO",
      "code": "EURO",
      "symbol": "€"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0920ec",
      "currency": "INR",
      "code": "INR",
      "symbol": "₹"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty657",
      "currency": "GBP",
      "code": "GBP",
      "symbol": "£"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty658",
      "currency": "JPY",
      "code": "JPY",
      "symbol": "¥"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty659",
      "currency": "AUD",
      "code": "AUD",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty660",
      "currency": "CAD",
      "code": "CAD",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty661",
      "currency": "CHF",
      "code": "CHF",
      "symbol": "CHF"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty662",
      "currency": "CNY",
      "code": "CNY",
      "symbol": "¥"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty663",
      "currency": "SGD",
      "code": "SGD",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty664",
      "currency": "HKD",
      "code": "HKD",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty665",
      "currency": "NZD",
      "code": "NZD",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty666",
      "currency": "ZAR",
      "code": "ZAR",
      "symbol": "R"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty667",
      "currency": "AED",
      "code": "AED",
      "symbol": "د.إ"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty668",
      "currency": "SAR",
      "code": "SAR",
      "symbol": "﷼"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty669",
      "currency": "MYR",
      "code": "MYR",
      "symbol": "RM"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty670",
      "currency": "THB",
      "code": "THB",
      "symbol": "฿"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty671",
      "currency": "IDR",
      "code": "IDR",
      "symbol": "Rp"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty672",
      "currency": "PHP",
      "code": "PHP",
      "symbol": "₱"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty673",
      "currency": "KRW",
      "code": "KRW",
      "symbol": "₩"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty674",
      "currency": "RUB",
      "code": "RUB",
      "symbol": "₽"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty675",
      "currency": "TRY",
      "code": "TRY",
      "symbol": "₺"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty676",
      "currency": "BRL",
      "code": "BRL",
      "symbol": "R$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty677",
      "currency": "MXN",
      "code": "MXN",
      "symbol": "$"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty678",
      "currency": "SEK",
      "code": "SEK",
      "symbol": "kr"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty679",
      "currency": "NOK",
      "code": "NOK",
      "symbol": "kr"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty680",
      "currency": "DKK",
      "code": "DKK",
      "symbol": "kr"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty681",
      "currency": "PLN",
      "code": "PLN",
      "symbol": "zł"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty682",
      "currency": "ILS",
      "code": "ILS",
      "symbol": "₪"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty683",
      "currency": "EGP",
      "code": "EGP",
      "symbol": "£"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty684",
      "currency": "KES",
      "code": "KES",
      "symbol": "KSh"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty685",
      "currency": "NGN",
      "code": "NGN",
      "symbol": "₦"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty686",
      "currency": "PKR",
      "code": "PKR",
      "symbol": "₨"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty687",
      "currency": "BDT",
      "code": "BDT",
      "symbol": "৳"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty688",
      "currency": "LKR",
      "code": "LKR",
      "symbol": "Rs"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty689",
      "currency": "NPR",
      "code": "NPR",
      "symbol": "Rs"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty690",
      "currency": "VND",
      "code": "VND",
      "symbol": "₫"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty691",
      "currency": "CZK",
      "code": "CZK",
      "symbol": "Kč"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty692",
      "currency": "HUF",
      "code": "HUF",
      "symbol": "Ft"
    },
    {
      "id": "f7db6eba-971b-43c8-aa5e-43324c0ty693",
      "currency": "RON",
      "code": "RON",
      "symbol": "lei"
    }
  ])

  // =========================
  // STORE KEY & REFERENCE NO
  // =========================
  useEffect(() => {
    if (location.state?.insuranceKey) {
      localStorage.setItem("insuranceKey", location.state.insuranceKey);
    }

    if (location.state?.insuranceReferenceNo) {
      localStorage.setItem(
        "insuranceReferenceNo",
        location.state.insuranceReferenceNo
      );
    }
  }, [location.state]);

  useEffect(() => {
    const fetchInsurancePlans = async () => {
      if (!searchData) return;

      try {
        setLoading(true);

        const corporateCode =
          localStorage.getItem(
            "selectedCorporateCode"
          );

        const userId =
          localStorage.getItem(
            "selectedUserId"
          );

        const params = {
          travelPurpose:
            Number(searchData?.travelPurpose) || 0,

          loggedInUserId:
            userName || "guest",

          corporateTraveller:
            userId || userName || "guest",

          corporateCode:
            corporateCode || corporateId || "",

          isEmulated: !!corporateCode,

          key:
            key ||
            localStorage.getItem(
              "insuranceKey"
            ) ||
            "",

          clientCode: "BerryJourneys",
          tripType: searchData?.tripType,

          trips: {
            duration:
              searchData?.trips?.duration || [],

            age:
              searchData?.trips?.age || [],

            category:
              searchData?.trips?.category || "",

            travelType:
              searchData?.trips?.travelType || "",

            startDate:
              searchData?.trips?.startDate || "",

            endDate:
              searchData?.trips?.endDate || "",

            partnerId:
              searchData?.trips?.partnerId ||
              "00004448-0000-0000-0000-000000000000",
          },
        };

        const res = await GetPlan(params);

        //console.log("FULL API RESPONSE", res);
        console.log(
          "PLAN ROOT",
          res?.externalCPPlanRootDto
        );

        // =========================
        // SAVE KEY & REFERENCE
        // =========================

        const apiKey =
          res?.key ||
          res?.data?.key ||
          res?.result?.key ||
          "";

        const apiRef =
          res?.referenceNo ||
          res?.data?.referenceNo ||
          res?.result?.referenceNo ||
          "";

        if (apiKey) {
          localStorage.setItem(
            "insuranceKey",
            apiKey
          );

          setKey((prev) =>
            prev || apiKey
          );
        }

        if (apiRef) {
          localStorage.setItem(
            "insuranceReferenceNo",
            apiRef
          );
        }

        // =========================
        // FORMAT PLANS
        // =========================

        const planData =
          res?.externalCPPlanRootDto ||
          res?.data?.externalCPPlanRootDto ||
          [];

        if (Array.isArray(planData)) {
          const formattedPlans = [];

          planData.forEach((insurer) => {
            insurer?.plans?.forEach((plan) => {
              formattedPlans.push({
                insurerId: insurer?.insurerId,
                insurerName: insurer?.insurerName,
                companyLogo: insurer?.insurerLogoPath,
                termsAndConditions:
                  insurer?.termsAndConditions,

                planId: plan?.id,

                planName:
                  plan?.displayName ||
                  plan?.name,

                sumInsured:
                  plan?.sumInsured ||
                  plan?.sumAssured,

                policyStatus: plan?.policyStatus,
                policyViolationReason: plan?.policyViolationReason,

                // premium:
                //   plan?.agePremiums?.[0]
                //     ?.premium || 0,

                premium: plan?.agePremiums.reduce(
                  (sum, item) => sum + (item.premium || 0),
                  0
                ),

                agePremiums:
                  plan?.agePremiums || [],

                coverages:
                  plan?.coverages || [],

                riders:
                  plan?.riders || [],

                assistantServices:
                  plan?.assistantServices || [],
              });
            });
          });

          console.log(
            "FORMATTED PLANS",
            formattedPlans
          );

          setInsurancePlans(formattedPlans);
        } else {
          setInsurancePlans([]);
        }
      } catch (err) {
        console.error(
          "API ERROR:",
          err
        );

        setInsurancePlans([]);
      } finally {
        setLoading(false);
      }
    };

    fetchInsurancePlans();
  }, [
    searchData,
    userName,
    corporateId
  ]);

  // =========================
  // FILTER PLANS
  // =========================
  useEffect(() => {
    if (insurancePlans.length === 0) {
      setFilteredPlans([]);
      return;
    }

    let filtered = [...insurancePlans];

    // Filter by Plan Type
    if (filters.planType && filters.planType.length > 0) {
      filtered = filtered.filter(plan =>
        filters.planType.some(type =>
          plan.planName?.toLowerCase().includes(type.toLowerCase()) ||
          plan.planType?.toLowerCase().includes(type.toLowerCase())
        )
      );
    }

    // Filter by Insurer
    if (filters.insurer && filters.insurer.length > 0) {
      filtered = filtered.filter(plan =>
        filters.insurer.some(insurer =>
          plan.insurerName?.toLowerCase().includes(insurer.toLowerCase())
        )
      );
    }

    // Filter by Sum Insured
    if (filters.sumInsured && filters.sumInsured.length > 0) {
      filtered = filtered.filter(plan => {
        const sumValue = plan.sumInsured || "";
        return filters.sumInsured.some(filterValue => {
          if (filterValue === 'Recommended') {
            return true; // Show all if Recommended is selected
          }
          return sumValue.includes(filterValue);
        });
      });
    }

    // Filter by Coverages
    if (filters.coverages && filters.coverages.length > 0) {
      filtered = filtered.filter(plan => {
        const planCoverages = plan.coverages?.map(c => c.name?.toLowerCase()) || [];
        return filters.coverages.some(coverage =>
          planCoverages.some(pc => pc.includes(coverage.toLowerCase()))
        );
      });
    }

    // Filter by Visa Type (if data available)
    if (filters.visaType && filters.visaType.length > 0) {
      // Add visa type filtering logic based on your data structure
      // This is a placeholder - adjust based on actual data
    }

    // Filter by Purpose of Travel (if data available)
    if (filters.purposeOfTravel && filters.purposeOfTravel.length > 0) {
      // Add purpose filtering logic based on your data structure
      // This is a placeholder - adjust based on actual data
    }

    // Sort by Premium
    if (filters.sortBy && filters.sortBy.length > 0) {
      if (filters.sortBy.includes('Premium low to high')) {
        filtered.sort((a, b) => (a.premium || 0) - (b.premium || 0));
      } else if (filters.sortBy.includes('Premium high to low')) {
        filtered.sort((a, b) => (b.premium || 0) - (a.premium || 0));
      }
    }

    setFilteredPlans(filtered);
  }, [filters, insurancePlans]);

  // =========================
  // HANDLE FILTER CHANGE
  // =========================
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  // =========================
  // HANDLE INSURANCE BOOKING
  // =========================

  const handleInsuranceBooking = async (
    selectedPlan,
    index
  ) => {
    if (loading) return;

    try {
      setLoading(true);
      setLoadingIndex(index);

      const keyValue =
        localStorage.getItem("insuranceKey") ||
        location.state?.insuranceKey ||
        "";

      if (!keyValue) {
        alert(
          "Insurance Key not found. Please search plans again."
        );
        return;
      }

      const corporateCode =
        localStorage.getItem(
          "selectedCorporateCode"
        ) || "";

      const userId =
        localStorage.getItem(
          "selectedUserId"
        ) || "";
      const requestBody = {
        referenceNo:
          localStorage.getItem(
            "insuranceReferenceNo"
          ) || "",

        travelPurpose:
          Number(searchData?.travelPurpose) || 0,

        loggedInUserId:
          userName || "guest",

        corporateTraveller:
          userId || userName || "guest",

        corporateCode:
          corporateCode ||
          corporateId ||
          "",

        isEmulated: Boolean(
          corporateCode
        ),

        key: keyValue,

        clientCode: "BerryJourneys",

        selectedInsurance: {
          insuranceId:
            selectedPlan?.insurerId || "",

          insuranceName:
            selectedPlan?.insurerName || "",

          insuranceLogoPath:
            selectedPlan?.companyLogo || "",

          termsAndConditions:
            selectedPlan?.termsAndConditions || "",

          plan: JSON.stringify(
            selectedPlan
          ),

          planId: selectedPlan.planId,
          planName: selectedPlan.planName,

          duration:
            searchData?.trips?.duration || [],

          age:
            searchData?.trips?.age || [],

          paxCount:
            searchData?.trips?.age?.length || 0,

          adultCount:
            searchData?.trips?.age?.length || 0,

          childCount: 0,

          infantCount: 0,

          category:
            searchData?.trips?.category || "",

          partnerId:
            searchData?.trips?.partnerId ||
            "00004448-0000-0000-0000-000000000000",

          startDate:
            searchData?.trips?.startDate || "",

          endDate:
            searchData?.trips?.endDate || "",

          policyStatus: selectedPlan.policyStatus,
          policyReason: selectedPlan.policyViolationReason,

          totalPremium:
            Number(
              selectedPlan?.premium
            ) || 0,
          ManagementFee: selectedPlan.managementFee || 0,
          ManagementFeeGST: selectedPlan.managementFeeGS || 0,
          CompanyAmount: 0,

          riders:
            selectedPlan?.riders || [],

          riderPremium:
            Number(
              selectedPlan?.riderPremium
            ) || 0,

          totalPremiumWithRiders:
            Number(
              selectedPlan?.premium || 0
            ) +
            Number(
              selectedPlan?.riderPremium || 0
            ),

        },
      };

      console.log(
        "SAVE INSURANCE REQUEST",
        requestBody
      );

      const response = await GetSelectedInsurance(requestBody);
      //console.log("SAVE INSURANCE RESPONSE", response);

      if (
        response?.status === "Success"
      ) {
        localStorage.setItem(
          "insuranceKey",
          response?.key || keyValue
        );

        localStorage.setItem(
          "insuranceReferenceNo",
          response?.referenceNo || ""
        );

        navigate(
          `/insurance/booking?referenceNo=${response?.referenceNo}&key=${response?.key}&clientCode=${response?.clientCode}`,
          {
            state: {
              bookingData: response,
              searchData,
              insuranceKey:
                response?.key,
              insuranceReferenceNo:
                response?.referenceNo,
            },
          }
        );
      } else {
        alert(
          response?.error ||
          response?.message ||
          "Failed to save insurance selection."
        );
      }
    } catch (err) {
      console.error(
        "BOOKING ERROR:",
        err?.response?.data || err
      );

      alert(
        err?.response?.data?.message ||
        "Failed to save insurance selection."
      );
    } finally {
      setLoading(false);
      setLoadingIndex(null);
    }
  };

  // Count active filters
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).reduce((sum, arr) => sum + arr.length, 0);
  }, [filters]);

  const getCurrencySymbol = (currencyCode) => {
    const currency = currencyList.find(c => c.id === currencyCode);
    return currency ? currency.code : currency.symbol;
  };

  const getInsurerName = (plan) => {
    const insurerName = plan?.insurerName?.replace(/\s+/g, " ").trim();
    if (insurerName === "Zurich Kotak General Insurance Company (India) Limited") {
      return <img
        src={`${InsuranceAPI_StaticFile_BASE_URL}/insurerLogo/Zurich.png`}
        alt={insurerName}
        className="logo_bank"
      />
    }
    else if (insurerName === "Care Health Insurance Limited A2A (Crest)") {
      return <img
        src={`${InsuranceAPI_StaticFile_BASE_URL}/insurerLogo/Care.png`}
        alt={insurerName}
        className="logo_bank"
      />
    }
    else if (insurerName === "HDFC ERGO General Insurance Company Limited") {
      return <img
        src={`${InsuranceAPI_StaticFile_BASE_URL}/insurerLogo/HDFC.png`}
        alt={insurerName}
        className="logo_bank"
      />
    }
    else if (insurerName === "ICICI Lombard General Insurance Co. Ltd") {
      return <img
        src={`${InsuranceAPI_StaticFile_BASE_URL}/insurerLogo/ICICI.png`}
        alt={insurerName}
        className="logo_bank"
      />
    }
    else {
      return <span>No image</span>;
    }
  };

  return (
    <>
      <Header></Header>
      <section className='wrapers results'>
        <div className='row'>
          <div className='col-md-3'>
            <InsuLeftfilter
              onFilterChange={handleFilterChange}
              insurancePlans={insurancePlans}
            />
          </div>
          <div className='col-md-9'>
            <div className="sort_ins">
              <div className="row">
                <div className="col-md-10 col-lg-10">
                  <div className="d-flex_bs flex-wrap align-items-center gap-2">

                    <span>
                      {searchData?.trips?.selectedCountryName || "-"}
                    </span>

                    <span>
                      <i className="fa fa-arrow-right"></i>
                    </span>

                    <span>
                      {searchData?.trips?.travelType}
                    </span>

                    <span>||</span>

                    <span className="red">
                      {searchData?.trips?.startDate}
                    </span>

                    <span>||</span>

                    <span className="red">
                      {searchData?.trips?.endDate}
                    </span>

                    <span>
                      || Insurance Plan :
                    </span>

                    {/* <span className="red">
                      {insurancePlans?.length || 0}
                    </span>
*/}
                    <span className="red">{filteredPlans?.length || 0}</span>
                    {activeFilterCount > 0 && (
                      <span className="badge text-danger ms-2">
                        {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''} active
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-2 col-lg-2 text-end">
                  <button
                    className="modify_btn_sr"
                    data-bs-toggle="modal"
                    data-bs-target="#ModifyInsResult"
                  >
                    Modify Result <i className="fa fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
            {/* Loading */}
            {loading && (
              <p className="text-center load"><span className="loader"></span></p>
            )}

            {/* No Data */}

            {/* {!loading &&
              insurancePlans.length ===
              0 && (
                <div className="text-center py-5">
                  <img src="/assets/images/insurance/no-result.png" alt="Img" className="no_result" />
                </div>
              )}*/}
            {!loading && filteredPlans.length === 0 && (
              <div className="text-center py-5">
                <img src="/assets/images/insurance/no-result.png" alt="Img" className="no_result" />
                {insurancePlans.length > 0 && (
                  <p className="mt-3 text-muted">No plans match your filter criteria</p>
                )}
              </div>
            )}

            <div className="result_repets_main">
              {filteredPlans.map(
                (plan, index) => (
                  <div
                    className="insuResult"
                    key={index}
                  >
                    <div className="row">
                      {/* Left Side */}
                      <div className="col-md-9">
                        <div className="row">

                          {/* Logo */}
                          <div className="col-md-4 col-lg-4">

                            {getInsurerName(plan)}
                            {/* <img
                              src={`${InsuranceAPI_StaticFile_BASE_URL}/insurerLogo/ICICI.png`}
                              alt={plan?.insurerName}
                              className="logo_bank"
                            /> */}
                            <div className="col-md-12">
                              <h6 className="travels">
                                {plan?.planName}
                              </h6>

                              <p className="">
                                {plan?.insurerName}
                              </p>

                              <p className="tag_items assured">
                                <img
                                  src="/assets/images/insurance/insurance.png"
                                  alt="icon"
                                />

                                Insured :
                                <span>
                                  {(() => {
                                    const value = plan?.sumInsured || "";
                                    const currency = value.startsWith("USD") ? "USD" : "INR";
                                    const amount = Number(
                                      value.replace("INR", "").replace("USD", "").trim()
                                    );

                                    return `${currency} ${amount.toLocaleString("en-IN")}`;
                                  })()}
                                  {/* {`INR ${Number(
                                    plan?.sumInsured?.replace("INR", "").trim()
                                  ).toLocaleString("en-IN")}`}
                                  {plan?.sumInsured} */}
                                </span>
                              </p>
                            </div>
                          </div>

                          {/* Details */}
                          <div className="col-md-8 col-lg-8 border-left-right">
                            <div className="row">

                              {/* Basic Details */}


                              {/* Riders */}
                              {plan?.riders?.length > 0 && (
                                <div className="col-md-12">
                                  <h6 className="coverage">
                                    Riders
                                  </h6>

                                  <ul className="list-disc">
                                    {plan?.riders
                                      ?.slice(0, 3)
                                      ?.map((rider, i) => (
                                        <li key={i}>
                                          {rider?.name}
                                          {rider?.premiumPercent && (
                                            <strong>
                                              {" "}
                                              (
                                              {
                                                rider?.premiumPercent
                                              }
                                              %)
                                            </strong>
                                          )}
                                        </li>
                                      ))}
                                  </ul>
                                </div>
                              )}

                              {/* Assistant Services */}
                              {plan?.assistantServices
                                ?.length > 0 && (
                                  <div className="col-md-12">
                                    <h6 className="coverage">
                                      Assistance Services
                                    </h6>

                                    <ul className="list-disc">
                                      {plan?.assistantServices
                                        ?.slice(0, 3)
                                        ?.map((service, i) => (
                                          <li key={i}>
                                            {service?.name}
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                )}

                              {/* Coverages */}
                              <div className="col-md-12">
                                <h6 className="coverage">
                                  Coverage
                                </h6>

                                <ul className="list-disc">
                                  {plan?.coverages
                                    ?.slice(0, 3)
                                    ?.map((coverage, i) => (
                                      <li key={i}>
                                        {coverage?.name}

                                        <strong>
                                          {" "}
                                          {
                                            coverage?.maxAmount
                                          }
                                        </strong>
                                      </li>
                                    ))}
                                </ul>

                                <p
                                  className="code-nav-link"
                                  data-bs-toggle="modal"
                                  data-bs-target="#allfeatures"
                                  onClick={() =>
                                    setSelectedPlan(plan)
                                  }
                                >
                                  View all features...
                                </p>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Price */}
                      <div className="col-md-3 col-lg-3">
                        <div className="price_view">
                          <div className="row">
                            <div className="col-md-12 col-lg-12">
                              <div className="flight_charge bus_price">
                                <p className="strt">
                                  Premium
                                </p>
                                <i className="fa fa-inr"></i>
                                {plan?.premium?.toFixed(2)}
                              </div>
                              {plan?.policyStatus !== null && plan?.policyStatus === "WithinPolicy" ? (
                                <>
                                  <p className="policyStatus text-success">
                                    <img
                                      alt="status"
                                      src="/assets/images/approved.png"
                                    />

                                    WithinPolicy
                                  </p>
                                </>
                              ) :
                                plan?.policyStatus !== null && plan?.policyStatus === "OutOfPolicy" ? (
                                  <>
                                    <p className="policyStatus text-danger">
                                      <img
                                        alt="status"
                                        src="/assets/images/cancelled.png"
                                      />

                                      OutOfPolicy
                                    </p>
                                  </>
                                ) : null
                              }


                              <button
                                className="btn-nav-link"
                                onClick={() =>
                                  handleInsuranceBooking(
                                    plan,
                                    index
                                  )
                                }
                                disabled={loadingIndex === index}
                              >
                                {loadingIndex === index
                                  ? "Processing..."
                                  : "Proceed"}
                              </button>
                              {/* <a
                                href={`${InsuranceAPI_StaticFile_BASE_URL}/termsAndConditions/${plan?.termsAndConditions?.replaceAll("/", "")}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="code-nav-link"
                              >
                                Terms & Conditions
                              </a> */}
                              {/* https://partner.asego.in/api */}
                              {plan?.termsAndConditions && (
                                <a
                                  href={`https://partner.asego.in/api/ext/b2b/v1/download?filePath=${plan?.termsAndConditions}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="code-nav-link"
                                >
                                  Terms & Conditions
                                </a>
                              )}


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </section>


      {/* Modify Result Modal */}
      <div
        className="modal fade"
        id="allfeatures"
        tabIndex="-1"
        aria-labelledby="allfeaturesLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="allfeaturesLabel">
                {selectedPlan?.planName} - All Features
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              {selectedPlan?.coverages?.length > 0 && (
                <div className="mb-4">
                  <h6 className="coverage mb-3">Insurance Benefits</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead className="table-light">
                        <tr>
                          <th>Coverage</th>
                          <th>Currency</th>
                          <th>Sum Insured</th>
                          <th>Deductibles</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedPlan.coverages.map((coverage, i) => (
                          <tr key={i}>
                            <td>{coverage?.name || "-"}</td>
                            {/* <td>{coverage?.currency || "INR"}</td> */}
                            <td>  {coverage?.currency ? (
                              <span>
                                {getCurrencySymbol(coverage.currency)}
                              </span>
                            ) : (
                              "-"
                            )}
                            </td>
                            <td>{coverage?.maxAmount || "-"}</td>
                            <td>{coverage?.deductibles || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {selectedPlan?.riders?.length > 0 && (
                <div className="mb-4">
                  <h6 className="coverage mb-3">Riders</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead className="table-light">
                        <tr>
                          <th>Rider Name</th>
                          <th>Premium</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedPlan.riders.map((rider, i) => (
                          <tr key={i}>
                            <td>{rider?.name || "-"}</td>
                            <td>
                              {rider?.premiumPercent ? (
                                <span>{rider.premiumPercent}% Extra</span>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {selectedPlan?.assistantServices?.length > 0 && (
                <div className="mb-4">
                  <h6 className="coverage mb-3">Assistance Services</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead className="table-light">
                        <tr>
                          <th>Service Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedPlan.assistantServices.map((service, i) => (
                          <tr key={i}>
                            <td>{service?.name || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {!selectedPlan?.coverages?.length &&
                !selectedPlan?.riders?.length &&
                !selectedPlan?.assistantServices?.length && (
                  <div className="text-center py-4">
                    <p className="text-muted mb-0">No Features Available</p>
                  </div>
                )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="Conditions">
        <div className="modal-dialog custom-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Terms & Conditions</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body-update">
              <div className='col-md-12 text-center'>
                <img src='/assets/images/pdf/ich-cond.PDF' />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="ModifyInsResult">
        <div className="modal-dialog custom-modal">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Modify Result</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body-update">
              <ModifySerchResult />
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default Insresult;
